import {
  call, put, takeLatest
} from "redux-saga/effects";
// Login Redux States
import {
  FETCH_REPORTS_START,
} from "./actionTypes";
import {
  fetchReportEnd,
  fetchReportFailure
} from "./actions";
import { showErrorNotification } from "store/notifications/actions";


import * as reportsApi from "../../apis/reports";

function* fetchReport(params) {
  try {
    const data = yield call(reportsApi.getReports, params);
    yield put(fetchReportEnd(data, params.requestId));
  }
  catch (error) {
    yield put(fetchReportFailure(error, params.requestId));
    yield put(showErrorNotification(error?.message || "Could not load report"));
  }

}
function* reportsSaga() {
  yield takeLatest(FETCH_REPORTS_START, fetchReport);
}

export default reportsSaga;
